// extracted by mini-css-extract-plugin
export var questionBox = "_64-0";